// extracted by mini-css-extract-plugin
module.exports = {"balance":"wallet-header_balance__fKNxo"};